import React, { useState } from 'react';
import SEO from '../../../components/SEO';
import Layout from '../../../components/Layout';
// import Container from '../../../components/Container';
import { Desktop, Tablet } from '../../../constants/responsive';
import { css } from '@emotion/core';
import { FormattedHTMLMessage, Link, useIntl } from 'gatsby-plugin-intl';
import Blank from '../../../components/Blank';
import { useStaticQuery, graphql } from 'gatsby';
import SGUQuestion from '../../../components/SGUDetailsQuestion';
import FooterFormBespoke from '../../../components/Footer/FooterFormBespoke';
import Container from '../../../components/Container';
import env from '../../../constants/environment';
import app from '../../../utils/bridges';
// import mpaasTracker from '../../../utils/mpaasTracker';
import { useMount } from 'react-use';
import lottie from 'lottie-web';
import Email from '../../../svgs/contact-us/email.svg';
import Phone from '../../../svgs/contact-us/phone.svg';
import Whatsapp from '../../../svgs/whatsapp.svg';
app.updateTitle('AQUMON Bespoke');

const FlexRow = ({ children, ...rest }) => {
  return (
    <div
      css={css`
        display: flex;
      `}
      {...rest}
    >
      {children}
    </div>
  );
};
const Item = ({ icon, children }) => {
  return (
    <div
      css={css`
        display: inline-block;
        align-items: flex-start;
        ${Desktop} {
          padding: 0 50px;
        }
      `}
    >
      <div
        css={css`
          width: 25px;
          margin-top: 13px;
          margin-right: 16px;
          float: left;
          ${Tablet} {
            margin-top: 3px;
          }
          ${Desktop} {
            margin-top: 6px;
          }
        `}
      >
        {icon}
      </div>
      {children}
    </div>
  );
};
const BespokeStep = ({ name, addition = true }) => {
  const imgMap = { one: 'step_1.png', two: 'step_2.png', three: 'step_3.png' };
  return (
    <div className='step'>
      <img
        css={css`
          width: 46px;
          height: 46px;
          ${Tablet} {
            width: 84px;
            height: 84px;
          }
        `}
        src={`/bespoke/${imgMap[name]}`}
      />
      <div className='content'>
        <Blank height={[0, 25, 25]} />
        <h3 className='h3'>
          <FormattedHTMLMessage id={`v5.hk_overseas.step_${name}_title`} />
        </h3>
        <Blank height={[5, 10, 10]} />
        <p className='h4'>
          <FormattedHTMLMessage
            id={`v5.hk_overseas.step_${name}_description`}
          />
        </p>
        <Blank height={[0, 20, 10]} />
        {addition && (
          <p className='h5'>
            <FormattedHTMLMessage id={`v5.hk_overseas.step_${name}_addition`} />
          </p>
        )}
      </div>
    </div>
  );
};

const MainlandChinaPage = () => {
  const intl = useIntl();
  const imgData = useStaticQuery(graphql`
    query {
      FerrisWheelPC: file(relativePath: { eq: "bespoke/ferris-wheel-pc.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      FerrisWheelIpad: file(
        relativePath: { eq: "bespoke/ferris-wheel-ipad.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      FerrisWheelMobile: file(
        relativePath: { eq: "bespoke/ferris-wheel-mobile.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  const [isLogin, setIsLogin] = useState(false);
  app
    .isLogin()
    .then((result) => {
      setIsLogin(result.isLogin);
    })
    .catch((err) => {
      console.log(err, 'error');
    });

  useMount(() => {
    // 点击联系我们，mpaas埋点
    /* mpaas包在服务端渲染和客户端渲染加载的时机不同。
    服务端渲染会加载快些，为了不使本地运行时报错，这里延迟1s调用 */
    setTimeout(() => {
      // mpaasTracker.View('Bespoke_LandingPage', {
      //   bizType: 'Page',
      // });
    }, 1000);

    const contactUsList = document.querySelectorAll('.contact-us');
    for (let i = 0; i < contactUsList.length; i++) {
      contactUsList[i].addEventListener('click', function() {
        // mpaasTracker.Click('Bespoke_LandingPage_ContactUs', {
        //   bizType: 'Button',
        // });
      });
    }

    var animation = lottie.loadAnimation({
      container: document.getElementById('banner-anm'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/bespoke/banner-bg.json',
    });
    lottie.setQuality('low');
  });
  return (
    <Layout
      footerBand={false}
      showFooter={!env.isAQMAPP}
      showHeader={!env.isAQMAPP}
    >
      <SEO
        title={intl.formatMessage({ id: 'professional-investors.title' })}
        description={intl.formatMessage({
          id: 'professional-investors.description',
        })}
        keywords={intl.formatMessage({ id: 'professional-investors.keywords' })}
      />

      <div
        className='main'
        css={css`
          width: 100%;
          background: #f8f8f8;
          display: flex;
          flex-direction: column;
          align-items: center;
        `}
      >
        {env.isAQMAPP && (
          <img
            className='app-buoy'
            src='/bespoke/app-buoy.png'
            onClick={() => {
              // mpaasTracker.Click('Bespoke_LandingPage_FloatIcon', {
              //   bizType: 'Button',
              //   ext: { uid: localStorage.getItem('uid') },
              // });
              if (isLogin) {
                app.showWebView(
                  process.env.GATSBY_ENV === 'live'
                    ? 'https://h5-app.aqumon.com/bespoke/bespoke.html'
                    : 'https://test-h5-app.aqumon.com/bespoke/bespoke.html'
                );
              } else {
                app.showLogin({
                  action: 'showWebView',
                  params: {
                    url: {
                      live: 'https://h5-app.aqumon.com/bespoke/bespoke.html',
                      test:
                        'https://test-h5-app.aqumon.com/bespoke/bespoke.html',
                    }[process.env.GATSBY_ENV],
                  },
                });
              }
            }}
          />
        )}

        {/* banner */}
        <div className='banner'>
          <div className='video' id='banner-anm'></div>
          <div className='content description'>
            <h1 className='title'>
              <FormattedHTMLMessage id={`v5.hk_overseas.banner_title`} />
            </h1>
            <Blank height={[38, 20, 29]} />
            <p className='banner-description'>
              <FormattedHTMLMessage id={`v5.hk_overseas.banner_description`} />
            </p>
            <Blank height={[20, 0, 20]} />
            <a className='link contact-us new-btn' href={`#contactUs`}>
              <FormattedHTMLMessage id={`v5.hk_overseas.contact_with_us`} />
              {/* &nbsp;&nbsp;&nbsp; */}
              {/* <span className='icon-arrow'>
                <img src='/icon/white-arrow.png' />
              </span> */}
            </a>
          </div>
        </div>
        <Blank height={[0, 100, 85]} />
        {/* 模块一 - 改动图 */}
        <Container>
          <div className='new-title'>
            <FormattedHTMLMessage id={`v5.hk_overseas.service_new_title`} />
          </div>
          <div className='services description add-item'>
            {['item1', 'item2'].map((value) => {
              return (
                <div key={value} className='service'>
                  <div className='message1'>
                    <img
                      css={css`
                        width: 228px;
                      `}
                      src={`/bespoke/${value}.png`}
                    />
                    <h3
                      className='h3'
                      css={css`
                        padding-top: 24px !important;
                      `}
                    >
                      <FormattedHTMLMessage
                        id={`v5.hk_overseas.service_${value}_title`}
                      />
                    </h3>
                  </div>
                </div>
              );
            })}
          </div>
        </Container>
        {/* 新增板块 */}
        <Container>
          <FlexRow className='team-experts'>
            <div className='description' style={{ color: '#161616' }}>
              <h2 className='h2'>
                <FormattedHTMLMessage
                  id={`v5.hk_overseas.team_experts_title`}
                />
              </h2>
              <Blank height={[28, 30, 30]} />
              <p
                className='h4'
                css={css`
                  width: auto;
                  white-space: normal;
                  ${Tablet} {
                    min-width: 650px;
                  }
                  ${Desktop} {
                    width: 100%;
                    white-space: nowrap;
                  }
                `}
              >
                <FormattedHTMLMessage
                  id={`v5.hk_overseas.team_experts_description`}
                />
              </p>
            </div>
          </FlexRow>
          <div className='services description add'>
            <Blank height={[38, 38, 37]} />
            <FlexRow className='content'>
              {['left-img', 'right-img'].map((value) => {
                return (
                  <div key={value} className='service'>
                    <img
                      css={css`
                        width: 238px;
                        height: 176px;
                      `}
                      src={`/bespoke/${value}.png`}
                    />
                    <div className='message1'>
                      <h3
                        className='h3'
                        css={css`
                          padding-bottom: 24px !important;
                          ${Desktop} {
                            white-space: nowrap;
                          }
                        `}
                      >
                        <FormattedHTMLMessage
                          id={`v5.hk_overseas.service_${value}_title`}
                        />
                      </h3>
                      <p className='h4'>
                        <FormattedHTMLMessage
                          id={`v5.hk_overseas.service_${value}_description`}
                        />
                      </p>
                    </div>
                  </div>
                );
              })}
            </FlexRow>
          </div>
        </Container>
        <Blank height={[50, 154, 180]} />
        {/* 新增板块  core 图 */}
        <FlexRow className='holistic-look core'>
          <div className='description'>
            <div className='core-right'>
              <h2
                className='h2'
                css={css`
                  color: #4c2480;
                  ${Desktop} {
                    width: 160px;
                  }
                `}
              >
                <FormattedHTMLMessage id={`v5.hk_overseas.core`} />
              </h2>
              <br />
              <h2 className='h2'>
                <FormattedHTMLMessage id={`v5.hk_overseas.core2`} />
              </h2>
            </div>
          </div>
          <div className='core-left'>
            <div
              className='picture-bg'
              css={css`
                background: no-repeat center;
                background-size: contain;
                background-image: url(${{
                  en: '/bespoke/corebg.png',
                  'zh-cn': '/bespoke/corebg_cn.png',
                  'zh-hk': '/bespoke/corebg_zh.png',
                }[intl.locale]});
                ${Tablet} {
                  // background: url('/bespoke/corebg.png') no-repeat center;
                  background-size: contain;
                }
                ${Desktop} {
                  // background: url('/bespoke/corebg.png') no-repeat center;
                  background-size: contain;
                }
              `}
            ></div>
          </div>
        </FlexRow>
        {/* 模块二 - 摩天轮 */}
        <FlexRow className='holistic-look'>
          <img
            className='picture-img'
            src={imgData['FerrisWheelMobile'].childImageSharp.fluid.src}
          />
          <div
            className='picture-bg'
            css={css`
              ${Tablet} {
                background: url(${imgData['FerrisWheelIpad'].childImageSharp
                    .fluid.src})
                  no-repeat;
              }
              ${Desktop} {
                background: url(${imgData['FerrisWheelPC'].childImageSharp.fluid
                    .src})
                  no-repeat;
              }
            `}
          ></div>
          <div className='description'>
            <h2 className='h2'>
              <FormattedHTMLMessage id={`v5.hk_overseas.strategised_title`} />
            </h2>
            <Blank height={[28, 30, 20]} />
            <p className='h4'>
              <FormattedHTMLMessage
                id={`v5.hk_overseas.strategised_description`}
              />
            </p>
            <Blank height={[20, 16, 16]} />
            <a
              className='link'
              onClick={() => {
                const url = ``;
                const langMap = {
                  en: 'en',
                  'zh-cn': 'zh-hans',
                  'zh-hk': 'zh-hant',
                };
                // mpaasTracker.Click('Bespoke_LandingPage_LearnMore', {
                //   bizType: 'Button',
                //   ext: { uid: localStorage.getItem('uid') },
                // });
                if (env.isAQMAPP) {
                  // app内跳转app的blog
                  app.showWebView(
                    `https://cms.aqumon.com/template/blog/929/share?language=${
                      langMap[intl.locale]
                    }`
                  );
                } else {
                  // app外跳转官网的blog
                  window.location.href = `https://www.aqumon.com/${intl.locale}/blog/929/asias-leading-wealthtech-platform-launches-aqumon-bespoke-exceptional-investments-for-the-discerning-investor/`;
                }
              }}
            >
              <FormattedHTMLMessage id={`v5.hk_overseas.learn_more`} />
              &nbsp;
              <span className='icon-arrow'>
                <img src='/icon/purple-arrow.png' />
              </span>
            </a>
          </div>
        </FlexRow>
        <Blank height={[100, 150, 200]} />
        {/* 模块三 - 4点服务 */}
        <Container>
          <div className='services description'>
            <h2 className='h2'>
              <FormattedHTMLMessage id={`v5.hk_overseas.services_title`} />
            </h2>
            <Blank height={[38, 38, 37]} />
            <FlexRow className='content'>
              {['advisor', 'investments', 'portfolios', 'benefits'].map(
                (value) => {
                  return (
                    <div key={value} className='service'>
                      <img
                        css={css`
                          width: 60px;
                          height: 60px;
                        `}
                        src={`/bespoke/${value}.png`}
                      />
                      <Blank height={[6, 6, 10]} />
                      <h3 className='h3'>
                        <FormattedHTMLMessage
                          id={`v5.hk_overseas.service_${value}_title`}
                        />
                      </h3>
                      <Blank height={[10, 10, 10]} />
                      <p className='h4'>
                        <FormattedHTMLMessage
                          id={`v5.hk_overseas.service_${value}_description`}
                        />
                      </p>
                    </div>
                  );
                }
              )}
            </FlexRow>
          </div>
        </Container>

        <Blank height={[70, 113, 180]} />
        {/* 模块四 - 3 steps */}
        <FlexRow className='module-four'>
          <div className='description'>
            <h2 className='h2'>
              <FormattedHTMLMessage id={`v5.hk_overseas.steps_module_title`} />
            </h2>
            <Blank height={[30, 50, 50]} />
            <FlexRow className='steps'>
              <BespokeStep name='one' />
              <div className='stepLine'></div>
              <BespokeStep name='two' addition={false} />
              <div className='stepLine'></div>
              <BespokeStep name='three' />
            </FlexRow>
          </div>
        </FlexRow>
        {/* 模块五 - 注册登录 */}
        {/* <div className='register'>
          <FooterFormBespoke />
        </div> */}
        <Container
          id='contactUs'
          css={css`
            background: url('/bespoke/bg4_m.png') center no-repeat;
            background-size: cover;
            width: 100% !important;
            ${Tablet} {
              background-image: url('/bespoke/bg4_m.png');
            }
          `}
        >
          <div
            css={css`
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              margin-top: 46px;
              text-align: left;

              ${Tablet} {
                text-align: center;
              }
              ${Desktop} {
                text-align: center;
                margin-left: 120px;
                margin-top: 140px;
              }
            `}
          >
            <div
              css={css`
                width: 100%;
                margin-right: 10%;
                ${Tablet} {
                  margin-bottom: 0px;
                  margin-right: 0px;
                  width: 56%;
                }
                ${Desktop} {
                  width: 45%;
                }
              `}
            >
              <p
                css={css`
                  font-weight: 500;
                  line-height: 38px;
                  font-size: 24px;
                  color: #333333;
                  margin-bottom: 44px;
                  ${Tablet} {
                    font-weight: 700;
                    font-size: 36px;
                    margin-bottom: 12px;
                  }
                  ${Desktop} {
                    font-size: 28px;
                    font-weight: 500;
                    margin-bottom: 44px;
                  }
                `}
              >
                <FormattedHTMLMessage id='menu.contact-us' />
              </p>
              <p
                css={css`
                  font-weight: 600;
                  font-size: 24px;
                  line-height: 41px;
                  color: #333333;
                  margin-bottom: 7px;
                  ${Tablet} {
                    font-weight: 700;
                    font-size: 28px;
                  }
                  ${Desktop} {
                    font-size: 30px;
                    font-weight: 600;
                  }
                `}
              >
                <FormattedHTMLMessage id='contact-us.Scientific' />
              </p>
              <p
                className='enhance'
                css={css`
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 27px;
                  color: #333333;
                  margin-bottom: 24px;
                  ${Tablet} {
                    font-size: 16px;
                  }
                  ${Desktop} {
                    font-size: 20px;
                    width: 100%;
                  }
                `}
              >
                <FormattedHTMLMessage id='contact-us.enhance' />
              </p>
              <Item icon={<Email />}>
                <h5 style={{ testAlign: 'left' }}>
                  <b
                    css={css`
                      display: block;
                      ${Tablet} {
                        display: inline-block;
                      }
                    `}
                  >
                    <FormattedHTMLMessage id='contact-us.email' />:
                  </b>{' '}
                  investmentsolutions@aqumon.com
                </h5>
              </Item>
              <Item icon={<Phone />}>
                <h5>
                  <b
                    css={css`
                      // display: block;
                      ${Tablet} {
                        display: inline-block;
                      }
                    `}
                  >
                    <FormattedHTMLMessage id='contact-us.hotline' />:
                  </b>{' '}
                  +852 3590 9951
                  <br />
                  <FormattedHTMLMessage id='contact-us.hours' />
                </h5>
              </Item>
            </div>
          </div>
        </Container>
        <Blank height={[50, 150, 200]} />
        {/* 模块六 - 常见问题 */}
        <FlexRow className='frequently-question description'>
          <h1 className='title h1'>
            <FormattedHTMLMessage id={`v5.hk_overseas.faq_module_title`} />
          </h1>
          <div className='questions-wrapper'>
            <SGUQuestion
              name='Q1'
              title={intl.formatMessage({ id: `v5.hk_overseas.faq_1_title` })}
              answer={intl.formatMessage({ id: `v5.hk_overseas.faq_1_answer` })}
            />
            <SGUQuestion
              name='Q2'
              title={intl.formatMessage({ id: `v5.hk_overseas.faq_2_title` })}
              answer={intl.formatMessage({ id: `v5.hk_overseas.faq_2_answer` })}
            />
            <SGUQuestion
              name='Q3'
              title={intl.formatMessage({ id: `v5.hk_overseas.faq_3_title` })}
              answer={intl.formatMessage({ id: `v5.hk_overseas.faq_3_answer` })}
            />
          </div>
        </FlexRow>
        <Blank height={[80, 180, 180]} />
      </div>
    </Layout>
  );
};

export default MainlandChinaPage;
